import {
  createPlugin,
  createRoutableExtension,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';
import { awsBillingApiRef, AwsBillingClient } from './api';

export const awsBillingPlugin = createPlugin({
  id: 'aws-billing',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: awsBillingApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new AwsBillingClient(discoveryApi, fetchApi),
    }),
  ],
});

export const AwsBillingPage = awsBillingPlugin.provide(
  createRoutableExtension({
    name: 'AwsBillingPage',
    component: () =>
      import('./components/BillingPage').then(m => m.BillingPage),
    mountPoint: rootRouteRef,
  }),
);
